export const DECLINED_COLLAPSED_COPY =
  "You declined to add Change your flight for any reason.";
